var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 46,
    height: 46,
    rx: 23,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5007 25.5002V28.0002H18.5007V25.5002H16.834V28.0002C16.834 28.9168 17.584 29.6668 18.5007 29.6668H28.5007C29.4173 29.6668 30.1673 28.9168 30.1673 28.0002V25.5002H28.5007ZM19.334 20.5002L20.509 21.6752L22.6673 19.5252V26.3335H24.334V19.5252L26.4923 21.6752L27.6673 20.5002L23.5007 16.3335L19.334 20.5002Z",
    fill: "#C7C7C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.d467964e8b12619b29685f1d6ea279ad.svg";
export { ForwardRef as ReactComponent };